"use client"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { createTRPCReact } from "@trpc/react-query"
import { httpBatchLink } from "@trpc/client"
import type { ReactNode } from "react"
import { useState } from "react"

import type { AppRouter } from "@/server/api/root"

export const trpc = createTRPCReact<AppRouter>()

const getBaseUrl = () => {
  if (typeof window !== "undefined") {
    return ""
  }

  return process.env.NEXTAUTH_URL_INTERNAL ?? "http://localhost:3011"
}

export const TrpcProvider = ({ children }: { children: ReactNode }) => {
  const [queryClient] = useState(() => new QueryClient())
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: `${getBaseUrl()}/api/trpc`,
        }),
      ],
    }),
  )

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  )
}
